import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { OrderFlowAuthService } from '../auth/order-flow-auth.service';
import { canViewOnlyPartialExecutions } from '../orders/order-permissions.utils';
import { Router } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-home',
  imports: [],
  template: ``
})
export class HomeComponent implements OnInit {
  private authService = inject(OrderFlowAuthService);
  private router = inject(Router);

  public ngOnInit(): void {
    if (canViewOnlyPartialExecutions(this.authService)) {
      this.router.navigate(['/partial-executions']);
    } else {
      this.router.navigate(['/orders']);
    }
  }
}
